import React from 'react';
import { Container } from '@mui/material';

import { UserHeader } from 'components/common/Header';
import TermsAndConditionsScreen from 'components/screens/TermsAndConditionsScreen';
import { TabTitle } from 'components/common/TabTitle';

function TermsOfUse() {
  return (
    <>
      <TabTitle ns="public" i18nKey="tab.terms" signLabel="general" />
      <UserHeader />
      <Container maxWidth="md" disableGutters>
        <TermsAndConditionsScreen />
      </Container>
    </>
  );
}

export default TermsOfUse;
